import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastrService } from '../services/toastr.service';

// Optional reads may intentionally encounter deleted or inaccessible resources.
export const SILENT_HTTP_STATUSES = new HttpContextToken<readonly number[]>(() => []);

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastrService = inject(ToastrService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (req.context.get(SILENT_HTTP_STATUSES).includes(error.status)) {
        return throwError(() => error);
      }
      console.warn("HTTPERROR", { req, error });
      // Strukturierte API-Fehler (mit errorType) werden vom Aufrufer behandelt
      const apiError = error.error as { errorType?: unknown } | null;
      if (apiError?.errorType === 'WRITE_PROTECTED') {
        toastrService.error("WRITE_PROTECTED");
        return throwError(() => error);
      }
      if (apiError?.errorType) {
        return throwError(() => error);
      }
      switch (error.status) {
        case 400:
          toastrService.error("ERROR_400");
          break;
        case 401:
          toastrService.error("ERROR_401");
          break;
        case 403:
          toastrService.error("ERROR_403");
          break;
        case 404:
          toastrService.error("ERROR_404");
          break;
        case 429:
          toastrService.error("ERROR_429", undefined, { timeOut: 20000 });
          break;
        case 500:
        case 502:
        case 503:
        case 504:
          toastrService.error("ERROR_500");
          break;
        default:
          toastrService.error("ERROR");
      }
      return throwError(() => error);
    })
  );
};